import {RedeemManager} from "@/Core/Redeem/RedeemManager";
import Util from "@/Master/Util";
import {LoginUIManager} from "@/Core/Login/LoginUIManager";
import {HttpConfig, HttpResponse} from "@/Fwk/Http/HttpConfig";
import {comRequest} from "@/Fwk/Http/comRequest";
import RequestMgr, {NetType} from "@/Fwk/Http/RequestMgr";
import {confJson} from "@/app/config/confJson";
import {redeemConst} from "@/Core/Redeem/RedeemConst";
import {isEmpty} from "@/app/utils/tool";


export default class WebRedeem {
    public static Instance = new WebRedeem();
    private isRequesting: boolean = false;

    public async RequestRedeemApply(account: string, amount: number, onFinish: (data: HttpResponse<ResponseRedeemApplyData>)=>void) {
        if (this.isRequesting) return;

        let requestData = {} as RequestRedeemApplyData;
        requestData.withdrawAccount = account;
        requestData.currency = redeemConst.currency;

        requestData.money = amount;

        requestData.payType = redeemConst.peyType;

        requestData.country = RedeemManager.Instance.country;
        requestData.city = RedeemManager.Instance.city;
        requestData.state = RedeemManager.Instance.state;
        requestData.userId = LoginUIManager.getLastUserId+'';
        requestData.zipCode = LoginUIManager.getLastUserZipCode;
        requestData.productId = confJson.productId+'';

        if (Util.isLog) {
            console.log(RedeemManager.tag, `兑换数据:${requestData}`)
        }
        const config: HttpConfig = {
            url: RequestMgr.getUrl(NetType.RedeemApply),
            method: 'POST',
            body: requestData,
        };
        const response = await this.DoSendRequest<ResponseRedeemApplyData>(config);
        onFinish(response);
    }

    // 请求兑换取消
    public async RequestRedeemCancel(orderId: string, onFinish: (data: HttpResponse<ResponseRedeemCancelData>)=>void) {
        if (this.isRequesting) return;
        if (isEmpty(orderId)) return;
        let sendData = {} as RequestRedeemCancelData;
        sendData.orderId = orderId;
        sendData.userId = LoginUIManager.getLastUserId+'';
        sendData.productId = confJson.productId.toString();
        if (Util.isLog) {
            console.log(RedeemManager.tag, `请求兑换取消:${sendData}`)
        }
        const config: HttpConfig = {
            url: RequestMgr.getUrl(NetType.RedeemCancel),
            method: 'POST',
            body: sendData,
        };
        const response = await this.DoSendRequest<ResponseRedeemCancelData>(config);
        onFinish(response);
    }


    // 请求兑换校验
    public async RequestRedeemCheck(payType: number, onFinish: (data: HttpResponse<ResponseRedeemCheckData>)=>void) {
        if (this.isRequesting) return;
        let sendData = {} as RequestRedeemCheckData;
        sendData.payType = payType;
        sendData.userId = LoginUIManager.getLastUserId+'';
        sendData.productId = confJson.productId.toString();
        if (Util.isLog) {
            console.log(RedeemManager.tag, `请求兑换校验:${sendData}`)
        }
        const config: HttpConfig = {
            url: RequestMgr.getUrl(NetType.RedeemCheck),
            method: 'POST',
            body: sendData,
        };
        const response = await this.DoSendRequest<ResponseRedeemCheckData>(config);
        // const responseData = response.data;
        onFinish(response);
    }

    // 请求兑换订单列表
    public async RequestRedeemOrderList(page: number,pageSize: number, onFinish: (data: ResponseRedeemOrderListData)=>void) {
        if (this.isRequesting) return;
        let sendData = {} as RequestRedeemOrderListData;
        sendData._orderBy = '1';
        sendData.userId = LoginUIManager.getLastUserId+'';
        sendData.pageNum = page;
        sendData.pageSize = pageSize;
        if (Util.isLog) {
            console.log(RedeemManager.tag, `请求兑换订单列表:${sendData}`)
        }
        const config: HttpConfig = {
            url: RequestMgr.getUrl(NetType.RedeemOrderList),
            method: 'POST',
            body: sendData,
        };
        const response = await this.DoSendRequest<ResponseRedeemOrderListData>(config);
        const responseData = response.data;
        if (response.code == 200 && responseData ){
            onFinish(responseData);
        }else{
            onFinish(responseData);
        }
    }


    // 请求兑换配置
    public async RequestRedeemConfig(onFinish: (data: ResponseRedeemConfigData[]) => void) {
        if (this.isRequesting) return;
        let sendData = {} as RequestRedeemConfigData;
        sendData.apiVersion = '2';
        sendData.userId = LoginUIManager.getLastUserId+'';
        if (Util.isLog) {
            console.log(RedeemManager.tag, `请求兑换订单列表:`,sendData)
        }
        const config: HttpConfig = {
            url: RequestMgr.getUrl(NetType.RedeemConfig),
            method: 'POST',
            body: sendData,
            // headers: {Authorization: LoginNetManager.Instance.getLoginToken+''},
        };
        const response = await this.DoSendRequest<ResponseRedeemConfigData[]>(config);
        const responseData = response.data;
        onFinish(responseData);
    }


    public async DoSendRequest<T>(config: HttpConfig): Promise<HttpResponse<T>> {
        this.isRequesting = true;
        config.isSerErrTips = true;
        const sendRequest = await comRequest<T>(config);
        this.isRequesting = false;
        return sendRequest;
    }



}

